// extracted by mini-css-extract-plugin
export var errorsContainer = "_qv-1";
export var link = "_qv-0";